<template lang="pug">
v-dialog(v-model="dialog", persistent, scrollable, max-width="1300")
  v-card(v-if="!welcomePassed")
    .pa-4
      h2.text-center.mb-4
        | All done!
      p.text-center.mb-4
        | Your company profile is complete.
        | Please answer the following questions
        | to create a tailored case,
        | so you can get valuable insights and guidance
        | on how to become a licensed sponsor.
      .btns
        .d-flex.justify-center
          v-btn(color="primary", @click="openCaseQuiz") continue
</template>

<script>
export default {
  data: () => ({
    welcomePassed: false,
  }),

  methods: {
    openCaseQuiz() {
      this.welcomePassed = true;
      this.$store.dispatch("flows/openQuiz", {
        alias: this.userflow.flow.alias,
      });
    },
  },

  computed: {
    dialog() {
      return (
        this.userflow &&
        this.userflow.status == "in progress" &&
        this.userflowCompany.status !== "in progress"
      );
    },

    userflow() {
      return this.$store.getters["flows/freeCase"];
    },

    userflowCompany() {
      return this.$store.getters["flows/freeCompany"];
    },
  },
};
</script>
